import { StyledEngineProvider } from '@mui/material';
import { ThemeProvider } from '@mui/material/styles';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import App from './App';
import { PersistGateContainer } from './components/PersistGateContainer';
import './index.css';
import { store } from './redux/configureStore';
import * as serviceWorker from './serviceWorker';

import ErrorBoundary from 'ErrorBoundary';
import { theme } from 'theme';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import Toast from 'v2/components/Toast';

const rootElement = document.getElementById('root');

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      retry: 1,
      cacheTime: 1000 * 60 * 30, // 30 minutes
    },
  },
});

ReactDOM.render(
  <ErrorBoundary>
    <Provider store={store}>
      <QueryClientProvider client={queryClient}>
        <StyledEngineProvider injectFirst>
          <ThemeProvider theme={theme}>
            <PersistGateContainer>
              <App />
              <Toast />
            </PersistGateContainer>
          </ThemeProvider>
        </StyledEngineProvider>
      </QueryClientProvider>
    </Provider>
  </ErrorBoundary>,
  rootElement
);

serviceWorker.unregister();
